var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.375.188h13.75v11H7.507l-3.265 2.578-1.117.945v-3.524H.375v-11ZM1.75 1.563v8.25H4.5v1.977l2.32-1.806.172-.171h5.758v-8.25h-11ZM15.5 2.938h4.125v11h-2.75v3.523l-4.383-3.523h-6.36l1.72-1.376h5.156L15.5 14.54v-1.976h2.75v-8.25H15.5V2.938Z",
    fill: "currentColor"
  })));
};

export default SvgMessage;